import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import api from "../lib/api";
import { toast } from "sonner";

export default function Account() {
  const { user, refresh } = useAuth();

  const bootstrap = async () => {
    try {
      await api.post("/admin/bootstrap");
      await refresh();
      toast.success("You are now an admin");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Failed");
    }
  };

  if (!user) return null;
  return (
    <div className="max-w-[900px] mx-auto px-6 lg:px-10 py-10">
      <h1 className="font-display font-black text-4xl sm:text-6xl tracking-tight">Account</h1>

      <div className="mt-10 grid sm:grid-cols-[auto_1fr] gap-6 items-start border border-neutral-200 p-6">
        {user.picture && <img src={user.picture} alt={user.name} className="w-20 h-20 object-cover border border-neutral-200" />}
        <div>
          <div className="font-display font-bold text-2xl">{user.name}</div>
          <div className="text-sm text-neutral-600">{user.email}</div>
          <div className="mt-3 inline-block text-[10px] uppercase tracking-widest font-bold bg-black text-white px-2 py-1">
            {user.role}{user.role === "seller" && user.seller_status ? ` · ${user.seller_status}` : ""}
          </div>
        </div>
      </div>

      <div className="mt-10 border border-neutral-200 p-6">
        <h2 className="font-display font-bold uppercase tracking-wider text-sm">Developer / First Admin</h2>
        <p className="text-sm text-neutral-600 mt-2 max-w-lg">
          If no admin exists yet, the first authenticated user can claim admin status (one-time). Only works while the system has zero admins.
        </p>
        <Button data-testid="admin-bootstrap-btn" onClick={bootstrap} className="mt-4 rounded-none bg-black hover:bg-neutral-800">
          Claim admin (if available)
        </Button>
      </div>
    </div>
  );
}
